import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { GridOptions } from "ag-grid";
import { Angular2Csv } from "angular2-csv";
import {  MatInput } from '@angular/material';
import { ConsigmentUploadService } from "app/d2z/service/consignment-upload.service";
import { TrackingDataService } from "app/d2z/service/tracking-data.service";
import { FormControl, FormGroup } from '@angular/forms';
import { NgxSpinnerService } from "ngx-spinner";
import * as XLSX from "xlsx";
declare var $: any;

interface dropdownTemplate {
  name: string;
  value: string;
}
@Component({
  selector: "d2z-driver-pickup",
  templateUrl: "./driver-pickup.component.html",
  styleUrls: ["./driver-pickup.component.css"],
})
export class DriverPickupComponent implements OnInit {
  @ViewChild('frominput', {
    read: MatInput
  }) frominput: MatInput;
  
  @ViewChild('toinput', {
    read: MatInput
  }) toinput: MatInput;
  @ViewChild("uploadShipmentFile")
  uploadShipmentFile: ElementRef;
  errorMsg: string;
  successMsg: String;
  fromDate: String;
  toDate: String;
  system: String;
  templateArray: dropdownTemplate[];
  template1: Boolean;
  private gridOptions: GridOptions;
  templateType: String;
  userId: String;
  private rowData: any[];
  uploadFile: File;
  goodsDescResponse: any;
  driverForm: FormGroup;

  constructor(
    public trackingDataService: TrackingDataService,
    public consigmentUploadService: ConsigmentUploadService,
    private spinner: NgxSpinnerService
  ) {
    this.driverForm = new FormGroup({
      refBarNum: new FormControl()
    });
    this.gridOptions = <GridOptions>{ rowSelection: "multiple" };
    this.gridOptions.columnDefs = [
      {
        headerName: "Reference number",
        field: "referenceNumber",
        width: 180,
        checkboxSelection: true,
        headerCheckboxSelection: function (params) {
          return params.columnApi.getRowGroupColumns().length === 0;
        },
      },
      {
        headerName: "Consignee Name",
        field: "consigneeName",
        width: 200,
      },
      {
        headerName: "Consignee Address",
        field: "consigneeAddr1",
        width: 100,
      },
      {
        headerName: "City",
        field: "consigneeCity",
        width: 100,
      },
      {
        headerName: "State",
        field: "consigneeState",
        width: 100,
      },
      {
        headerName: "Postcode",
        field: "consigneePostcode",
        width: 100,
      },
      {
        headerName: "Country",
        field: "consigneeCountry",
        width: 100,
      },
      {
        headerName: "Description of goods",
        field: "descriptionOfGoods",
        width: 250,
      },
      {
        headerName: "Pkgs",
        field: "pkgs",
        width: 100,
      },
      {
        headerName: "Landing",
        field: "landing",
        width: 100,
      },
      {
        headerName: "Weight",
        field: "weight",
        width: 100,
      },
      {
        headerName: "Shipper Name",
        field: "shipperName",
        width: 100,
      },
      {
        headerName: "Shipper Address",
        field: "shipperAddr1",
        width: 140,
      },
      {
        headerName: "Shipper City",
        field: "shipperCity",
        width: 140,
      },
      {
        headerName: "Shipper State",
        field: "shipperState",
        width: 140,
      },
      {
        headerName: "Shipper Postcode",
        field: "shipperPostcode",
        width: 140,
      },
      {
        headerName: "Shipper Country",
        field: "shipperCountry",
        width: 140,
      },
      {
        headerName: "Origin Port",
        field: "originPort",
        width: 140,
      },
      {
        headerName: "Dest Port",
        field: "destPort",
        width: 140,
      },
      {
        headerName: "Total Value",
        field: "totalValue",
        width: 140,
      },
      {
        headerName: "Goods Currency",
        field: "goodsCurrency",
        width: 140,
      },
    ];
  }

  ngOnInit() {
    this.userId = this.consigmentUploadService.userMessage.user_id;
    this.system =
      document.location.hostname.includes("speedcouriers.com.au") == true
        ? "Speed Couriers"
        : "D2Z";

    this.templateArray = [
      { name: "CT Template.csv", value: "ct-template-csv" },
      { name: "PFL Template.xlsx", value: "pfl-template-xlsx" },
    ];
    this.templateType = this.templateArray[0].value;
  }

  FromDateChange(event){
    var str = event.target.value;
    var date = new Date(str),
          mnth = ("0" + (date.getMonth()+1)).slice(-2),
          day  = ("0" + date.getDate()).slice(-2);
     this.fromDate = [ date.getFullYear(), mnth, day ].join("-");
  };

  ToDateChange(event){
    var str = event.target.value;
    var date = new Date(str),
          mnth = ("0" + (date.getMonth()+1)).slice(-2),
          day  = ("0" + date.getDate()).slice(-2);
     this.toDate = [ date.getFullYear(), mnth, day ].join("-");
  };
  UploadedManifestFile(event) {
    this.uploadFile = event.target.files[0];
    if (this.uploadFile == undefined) {
      return;
    }

    this.spinner.show();
    let fileReader = new FileReader();
    fileReader.readAsArrayBuffer(this.uploadFile);

    fileReader.onload = (e) => {
      var arrayBuffer = fileReader.result;
      var data = new Uint8Array(arrayBuffer);
      var arr = new Array();
      for (var i = 0; i != data.length; ++i)
        arr[i] = String.fromCharCode(data[i]);
      var bstr = arr.join("");
      var workbook = XLSX.read(bstr, { type: "binary" });
      var first_sheet_name = workbook.SheetNames[0];
      var worksheet = workbook.Sheets[first_sheet_name];
      var exportData = XLSX.utils.sheet_to_json(worksheet);
      var response = [];
      var goodsDesRequest = [];
      for (var importVal in exportData) {
        var dataObj = exportData[importVal];
        var importObj =
          ((importObj = {}),
          (importObj["referenceNumber"] =
            dataObj["hawb"] != undefined ? dataObj["hawb"] : ""),
          importObj,
          (importObj["consigneeName"] =
            dataObj["Customer Name"] != undefined
              ? dataObj["Customer Name"]
              : ""),
          importObj,
          (importObj["consigneeAddr1"] =
            dataObj["Customer Address"] != undefined
              ? dataObj["Customer Address"]
              : ""),
          importObj,
          (importObj["city"] =
            dataObj["City"] != undefined ? dataObj["City"] : ""),
          importObj,
          (importObj["consigneeState"] =
            dataObj["State"] != undefined ? dataObj["State"] : ""),
          importObj,
          (importObj["consigneePostcode"] =
            dataObj["Postcode"] != undefined ? dataObj["Postcode"] : ""),
          importObj,
          (importObj["consigneeCountry"] =
            dataObj["Country"] != undefined ? dataObj["Country"] : ""),
          importObj,
          (importObj["descriptionOfGoods"] =
            dataObj["Description of goods"] != undefined
              ? dataObj["Description of goods"]
              : ""),
          importObj,
          (importObj["pkgs"] =
            dataObj["count"] != undefined ? dataObj["count"] : ""),
          importObj,
          (importObj["landing"] =
            dataObj["landing"] != undefined ? dataObj["landing"] : ""),
          importObj,
          (importObj["weight"] =
            dataObj["Weight"] != undefined ? dataObj["Weight"] : ""),
          importObj,
          (importObj["shipperName"] =
            dataObj["Shipper Name"] != undefined
              ? dataObj["Shipper Name"]
              : ""),
          importObj,
          (importObj["shipperAddress"] =
            dataObj["Shipper Address"] != undefined
              ? dataObj["Shipper Address"]
              : ""),
          importObj,
          (importObj["shipperCity"] =
            dataObj["Shipper City"] != undefined
              ? dataObj["Shipper City"]
              : ""),
          importObj,
          (importObj["shipperState"] =
            dataObj["Shipper State"] != undefined
              ? dataObj["Shipper State"]
              : ""),
          importObj,
          (importObj["shipperPostcode"] =
            dataObj["Shipper Postcode"] != undefined
              ? dataObj["Shipper Postcode"]
              : ""),
          importObj,
          (importObj["shipperCountry"] =
            dataObj["Shipper Country"] != undefined
              ? dataObj["Shipper Country"]
              : ""),
          importObj,
          (importObj["originPort"] =
            dataObj["Origin Port"] != undefined ? dataObj["Origin Port"] : ""),
          importObj,
          (importObj["destPort"] =
            dataObj["Dest Port"] != undefined ? dataObj["Dest Port"] : ""),
          importObj,
          (importObj["totalValue"] =
            dataObj["Total Value"] != undefined ? dataObj["Total Value"] : ""),
          importObj,
          (importObj["goodsCurrency"] =
            dataObj["Goods currency"] != undefined
              ? dataObj["Goods currency"]
              : ""),
          importObj);

        response.push(importObj);
      
        goodsDesRequest.push( importObj["referenceNumber"]);
      }
      this.rowData = response;
      this.template1 = true;
    
      
       this.trackingDataService.goodsDescription(goodsDesRequest, (resp) => {
          if(resp){
            this.goodsDescResponse = JSON.parse(JSON.stringify(resp));
          }
          this.spinner.hide();
         });
       
      //console.log(response);
      
    };
  }
  getNewDescription(key: any, oldDesc: any) {
    if(!this.goodsDescResponse) return null;
    if(key in this.goodsDescResponse){
     return this.goodsDescResponse[key];
    }else{
     return oldDesc;
    }
 }
 getReferenceNumber(refNum: String){
      if(refNum.length>40){
      return refNum.substring(18);
      }
      return refNum;
 }
  downloadShipmentDetails() {
    var currentTime = new Date();
    var shipmentList = [];
    var fileName = "";
    var selectedRowsTemplate = this.gridOptions.api.getSelectedRows();
    if (selectedRowsTemplate.length > 0) {
      if (this.templateType == "ct-template-csv") {
        fileName =
          "Shipment_Details_CT_Template" +
          "-" +
          currentTime.toLocaleDateString();
        var options = {
          fieldSeparator: ",",
          quoteStrings: '"',
          decimalseparator: ".",
          showLabels: true,
          useBom: true,
          headers: [
            "House Bill",
            "ETA",
            "Consignee Name",
            "Consignee Address1",
            "Consignee Address2",
            "Consignee State",
            "Consignee City",
            "Consignee Country",
            "Counsignee Postcode",
            "Consignee Phone",
            "Consignee Contact",
            "IATA Dest Port",
            "Cbms",
            "Weight",
            "Pieces",
            "Item Code",
            "Customs Value",
            "Description of Goods",
            "Flight No",
            "Master Bill",
            "IATA Load Port",
            "Shipper Name",
            "Shipper AddressLine1",
            "Shipper AddressLine2",
            "Shipper City",
            "Shipper Country",
            "Shipper Postcode",
            "Port Destination",
            "Description Changed"
          ],
        };

        let referenceNumber = "referenceNumber";
        let ETA = "ETA";
        let consigneeName = "consigneeName";
        let consigneeAddr1 = "consigneeAddr1";
        let consigneeAddr2 = "consigneeAddr2";
        let consigneeCity = "consigneeCity";
        let consigneeState = "consigneeState";
        let consigneeCountry = "consigneeCountry";
        let consigneePostcode = "consigneePostcode";
        let consigneePhone = "consigneePhone";
        let ConsigneeContact = "Consignee Contact";
        let injectionState = "injectionState";
        let Cbms = "Cbms";
        let weight = "weight";
        let shippedQuantity = "shippedQuantity";
        let itemCode = "itemCode";
        let value = "value";
        let productDescription = "productDescription";
        let flightNo = "flightNo";
        let airwayBill = "airwayBill";
        let loadPart = "loadPart";
        let shipperName = "shipperName";
        let shipperAddr1 = "shipperAddr1";
        let shipperAddr2 = "shipperAddr2";
        let shipperCity = "shipperCity";
        let shipperCountry = "shipperCountry";
        let shipperPostcode = "shipperPostcode";
        let consigneeCountryinjectionState = "consigneeCountryinjectionState";
        let descriptionChanged = "descriptionChanged";

        for (var importVal in selectedRowsTemplate) {
          var adminObj = selectedRowsTemplate[importVal];
          let prodDesc = this.getNewDescription(adminObj.referenceNumber,adminObj.descriptionOfGoods);
          var printObj =
            ((printObj = {}),
            (printObj[referenceNumber] = this.getReferenceNumber(adminObj.referenceNumber)),
            printObj,
            (printObj[ETA] = ""),
            printObj,
            (printObj[consigneeName] = adminObj.consigneeName),
            printObj,
            (printObj[consigneeAddr1] = adminObj.consigneeAddr1.trim()),
            printObj,
            (printObj[consigneeAddr2] = ""),
            printObj,
            (printObj[consigneeState] = adminObj.consigneeState),
            printObj,
            (printObj[consigneeCity] = adminObj.city ),
            printObj,
            (printObj[consigneeCountry] = "AU"),
            printObj,
            (printObj[consigneePostcode] = adminObj.consigneePostcode),
            printObj,
            (printObj[consigneePhone] = ""),
            printObj,
            (printObj[ConsigneeContact] = ""),
            printObj,
            (printObj[injectionState] = adminObj.destPort),
            printObj,
            (printObj[Cbms] = ""),
            printObj,
            (printObj[weight] = adminObj.weight),
            printObj,
            (printObj[shippedQuantity] = adminObj.pkgs),
            printObj,
            (printObj[itemCode] = "NDX"),
            printObj,
            (printObj[value] = adminObj.totalValue),
            printObj,
            (printObj[productDescription] = prodDesc),
            printObj,
            (printObj[flightNo] = ""),
            printObj,
            (printObj[airwayBill] = ""),
            printObj,
            (printObj[loadPart] = adminObj.originPort),
            printObj,
            (printObj[shipperName] = adminObj.shipperName),
            printObj,
            (printObj[shipperAddr1] =
              adminObj.shipperAddress == undefined ? "" : adminObj.shipperAddress),
            printObj,
            (printObj[shipperAddr2] = ""),
            printObj,
            (printObj[shipperCity] = adminObj.shipperCity),
            printObj,
            (printObj[shipperCountry] = adminObj.shipperCountry),
            printObj,
            (printObj[shipperPostcode] = adminObj.shipperPostcode),
            printObj,
            (printObj[consigneeCountryinjectionState] =
              adminObj.consigneeCountry + adminObj.destPort),
            printObj
        //   (printObj[descriptionChanged] =  prodDesc === adminObj.descriptionOfGoods? 'N' : 'Y'),
          //  printObj 
          );
          shipmentList.push(printObj);
        }
        new Angular2Csv(shipmentList, fileName, options);
      } else if (this.templateType == "pfl-template-xlsx") {
        fileName =
          "Shipment_Details_PFL_Template" +
          "-" +
          currentTime.toLocaleDateString();
        var options = {
          fieldSeparator: ",",
          quoteStrings: '"',
          decimalseparator: ".",
          showLabels: true,
          useBom: true,
          headers: [
            "HAWB",
            "Customer Code",
            "Customer Name",
            "Customer Address",
            "City",
            "State",
            "Postcode",
            "Country",
            "Description of goods",
            "Pkgs",
            "landing",
            "Weight",
            "Shipper Code",
            "Shipper Name",
            "Shipper Address",
            "Shipper City",
            "Shipper State",
            "Shipper Postcode",
            "Shipper Country",
            "Origin Port",
            "Dest Port",
            "Total Value",
            "Goods currency",
            "Lower value Flag",
            "Reference",
            "SUBMASTER",
            "Pkgs description",
            "Country of origin",
            "Cyber Vendor Account",
            "Vender Customs Code",
            "Cyber Importer Account",
            "Importer ABN",
            "Importer CAC",
            "Cyber Supplier Account",
            "Supplier Customs Code",
            "MAWB",
            "Console Port Orign",
            "Console Port Destination",
            "AirLine No",
            "ETD"
          ],
        };

        let referenceNumber = "referenceNumber";
        let customerCode = "Customercode";
        let consigneeName = "consigneeName";
        let consigneeAddr1 = "consigneeAddr1";
        let consigneeCity = "consigneeCity";
        let consigneeState = "consigneeState";
        let consigneePostcode = "consigneePostcode";
        let consigneeCountry = "consigneeCountry";
        let productDescription = "productDescription";
        let shippedQuantity = "shippedQuantity";
        let itemCode = "itemCode";
        let weight = "weight";
        let shipperCode = "shippercode";
        let shipperName = "shipperName";
        let shipperAddr = "shipperAddr";
        let shipperCity = "shipperCity";
        let shipperState = "shipperState";
        let shipperPostcode = "shipperPostcode";
        let shipperCountry = "shipperCountry";
        let OriginPort = "OriginPort";
        let DestPort = "injectionState";
        let value = "value";
        let goodsCurrency = "currency";
        let lowervalue = "lowervalue";
        let descriptionChanged = "descriptionChanged";

        for (var importVal in selectedRowsTemplate) {
          var adminObj = selectedRowsTemplate[importVal];
          let prodDesc = this.getNewDescription(adminObj.referenceNumber,adminObj.descriptionOfGoods);
          var printObj =
            ((printObj = {}),
            (printObj[referenceNumber] = this.getReferenceNumber(adminObj.referenceNumber)),
            printObj,
            (printObj[customerCode] = ""),
            printObj,
            (printObj[consigneeName] = adminObj.consigneeName),
            printObj,
            (printObj[consigneeAddr1] = adminObj.consigneeAddr1.trim()),
            printObj,
            (printObj[consigneeCity] = adminObj.city),
            printObj,
            (printObj[consigneeState] = adminObj.consigneeState),
            printObj,
            (printObj[consigneePostcode] = adminObj.consigneePostcode),
            printObj,
            (printObj[consigneeCountry] = "AU"),
            printObj,
            (printObj[productDescription] = prodDesc),
            printObj,
           //  (printObj[descriptionChanged] =  prodDesc === adminObj.descriptionOfGoods? 'N' : 'Y'),
           // printObj,
            (printObj[shippedQuantity] = adminObj.pkgs),
            printObj,
            (printObj[itemCode] = adminObj.landing),
            printObj,
            (printObj[weight] = adminObj.weight),
            printObj,
            (printObj[shipperCode] = ""),
            printObj,
            (printObj[shipperName] = adminObj.shipperName),
            printObj,
            (printObj[shipperAddr] =  adminObj.shipperAddress),
            printObj,
            (printObj[shipperCity] = adminObj.shipperCity),
            printObj,
            (printObj[shipperState] = adminObj.shipperState),
            printObj,
            (printObj[shipperPostcode] = adminObj.shipperPostcode),
            printObj,
            (printObj[shipperCountry] = adminObj.shipperCountry),
            printObj,
            (printObj[OriginPort] = adminObj.originPort),
            printObj,
            (printObj[DestPort] = adminObj.destPort),
            printObj,
            (printObj[value] = adminObj.totalValue),
            printObj,
            (printObj[goodsCurrency] = adminObj.goodsCurrency),
            printObj,
            (printObj[lowervalue] = "Y"),
            printObj);
          shipmentList.push(printObj);
        }
        new Angular2Csv(shipmentList, fileName, options);
      }
    } else {
      this.errorMsg =
        "**Please select the below records to download the Shipment details";
    }
  }

  clearshipmentdata() {
    this.uploadShipmentFile.nativeElement.value = "";
    this.template1 = false;
    this.rowData = [];
    this.uploadFile = null;
  }

  onTemplateChange(event) {
    this.templateType = event.value.value;
  }

  onSelectionChange() {
    var selectedRows = this.gridOptions.api.getSelectedRows();
    this.errorMsg = null;
  }
  downloadDriverDataReport(){
      this.spinner.show();
      this.consigmentUploadService.getDriverData(this.fromDate, this.toDate, (resp) => {
        this.spinner.hide();
        var shipmentList = [];

        var fileName =
          "Shipment_Report"
       
          var options = { 
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalseparator: '.',
            showLabels: true, 
            useBom: true,
            headers: [ 
              "Broker Name",
              "Article ID",
              "Reference Number",
              "PostCode",
              "Weight",
              "ServiceType",
              "Shipment Number",
              "Consignment Created Date",
              "value",
              "Del Name",
              "Del Addr1",
              "Del Addr2",
              "Suburb",
              "State",
              "Product Description",
              "Customer Reference",
              "Carrier",
              "Consignee_Phone",
              "Sort Chute",
              "Length",
              "Width",
              "Height"
            ]
          };
          let broker_name='broker_name';
          let reference_No = 'reference_No';
          let article_Id = 'article_Id';
          let delname = 'delname';
          let deladdr1  = 'deladdr1';
          let deladdr2 = 'deladdr2';
          let suburb = 'suburb';
          let state = 'state';
          let postCode = 'postCode';
          let value = 'value';
          let product_description = 'product_description';
          let weight = 'weight';
          let dat ='dat';
          let servicetype = 'servicetype';
          let shipmentNumber = 'shipmentNumber';
          let cust_reference  = 'cust_reference';
          let carrier = 'carrier';
          let phone = 'phone';
          let sortChute = 'sortChute';
          let length = 'length';
          let width = 'width';
          let height = 'height'
          for (var importVal in resp) {
              var shipmentObj = resp[importVal];
              console.log( shipmentObj.value);
              var shipmentMainObj = (
                shipmentMainObj={},
                shipmentMainObj[broker_name]= shipmentObj.broker_name != null ? shipmentObj.broker_name: '',shipmentMainObj,
                shipmentMainObj[article_Id]= shipmentObj.articleID != null ? shipmentObj.articleID : '', shipmentMainObj,
                shipmentMainObj[reference_No]= shipmentObj.reference_number != null ? shipmentObj.reference_number : '', shipmentMainObj,
                shipmentMainObj[postCode]= shipmentObj.consignee_Postcode != null ? shipmentObj.consignee_Postcode: '', shipmentMainObj,
                shipmentMainObj[weight]= shipmentObj.weight == null || shipmentObj.weight == '0.0'?'': shipmentObj.weight, shipmentMainObj,
                shipmentMainObj[servicetype]= shipmentObj.servicetype != null ? shipmentObj.servicetype: '', shipmentMainObj,
                shipmentMainObj[shipmentNumber]= shipmentObj.manifest != null ? shipmentObj.manifest: '', shipmentMainObj,
                shipmentMainObj[dat]= shipmentObj.dat != null ? shipmentObj.dat: '', shipmentMainObj,
                shipmentMainObj[value]= shipmentObj.value == null || shipmentObj.value == '0.0'? '': shipmentObj.value, shipmentMainObj,
                shipmentMainObj[delname]= shipmentObj.consignee_name != null ? shipmentObj.consignee_name: '', shipmentMainObj,
                shipmentMainObj[deladdr1]= shipmentObj.consignee_addr1 != null ? shipmentObj.consignee_addr1: '', shipmentMainObj,
                shipmentMainObj[deladdr2]= shipmentObj.consignee_addr2 != null ? shipmentObj.consignee_addr1: '', shipmentMainObj,
                shipmentMainObj[suburb]= shipmentObj.consignee_Suburb != null ? shipmentObj.consignee_Suburb: '', shipmentMainObj,
                shipmentMainObj[state]= shipmentObj.consignee_State != null ? shipmentObj.consignee_State: '', shipmentMainObj,
                shipmentMainObj[product_description]= shipmentObj.product_Description != null ? shipmentObj.product_Description: '', shipmentMainObj,
                shipmentMainObj[cust_reference]= shipmentObj.cust_reference != null ? shipmentObj.cust_reference: '', shipmentMainObj,
                shipmentMainObj[carrier]= shipmentObj.carrier != null ? shipmentObj.carrier: '', shipmentMainObj,
                shipmentMainObj[phone]= shipmentObj.consignee_Phone != null ? shipmentObj.consignee_Phone: '', shipmentMainObj,
                shipmentMainObj[sortChute]= shipmentObj.sortChute != null ? shipmentObj.sortChute: '', shipmentMainObj,
                shipmentMainObj[length]= shipmentObj.length != null ? shipmentObj.length: '', shipmentMainObj,
                shipmentMainObj[width]= shipmentObj.width != null ? shipmentObj.width: '', shipmentMainObj,
                shipmentMainObj[height]= shipmentObj.height != null ? shipmentObj.height: '', shipmentMainObj

              );
            
              shipmentList.push(shipmentMainObj)
          }
        new Angular2Csv(shipmentList, fileName, options);        

        setTimeout(() => {
          this.spinner.hide();
        }, 5000);
      });
  
  }
  driverScan(){
    
    this.errorMsg=null;
    this.successMsg=null;
    var elem = document.getElementById("pdf-Util");
    var that = this;
    elem.onkeyup = function(e){
        if(e.code == 'Enter'){
          var numberOfLineBreaks = '';
          numberOfLineBreaks = (that.driverForm.value.refBarNum.match(/\n/g)||[]).length;
          if(that.driverForm.value.refBarNum != null && $("#pdf-Util").val().length > 1){
                that.spinner.show();
                var fileRefNum = that.driverForm.value.refBarNum;
                that.consigmentUploadService.saveDriverData(that.driverForm.value.refBarNum.trim(),(resp) => {
                that.spinner.hide();
                  if(resp.status === 500){
                    that.errorMsg =' Invalid "Reference Number"';
                  }else{
                    that.driverForm.patchValue({
                      refBarNum: ''
                    })
                  }
                })
          }else{
            that.spinner.hide();
            that.errorMsg =  '*Please enter the "Reference Number".';
          }
        }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/d2z/views/superuser-level/create-shipment/driver-pickup/driver-pickup.component.ts